import {
  LoadingOutlined,
  PauseCircleOutlined,
  CheckOutlined,
  ClockCircleOutlined,
} from "@ant-design/icons";

export const estadoConfig = {
  1: { color: "#faad14", text: "Pendiente", icon: <ClockCircleOutlined /> },
  2: { color: "#40a9ff", text: "En Proceso", icon: <LoadingOutlined /> },
  4: { color: "#f50", text: "Pausada", icon: <PauseCircleOutlined /> },
  3: { color: "#008000", text: "Finalizada", icon: <CheckOutlined /> },
};
